export enum Frequency {
  Monthly,
  Annually,
}

export enum MatchType {
  NotSure,
  None,
  FiftyPercent,
  OneHundredPercent,
  OtherPercent,
  SafeHarbor1,
  SafeHarbor2,
  PercentageOfCompensation,
  NonElective,
  MultiTier,
}

export enum Unit {
  Dollar,
  Percentage,
}

export enum TaxStatus {
  Traditional,
  Roth,
  AfterTax,
}
